import { FileField as FormFileField } from "components/shared/form";
import React from "react";

export default class FileField extends FormFileField {
    render() {
        return (
            <>
                {this.renderField()}
                {this.renderError()}
            </>
        );
    }
}
